
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Group 132657","xmlns":"http://www.w3.org/2000/svg","width":"26","height":"26","viewBox":"0 0 26 26"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Ellipse 1729","fill":"rgba(93,62,189,0)","stroke":"#fff"}},[_c('circle',{attrs:{"cx":"13","cy":"13","r":"13","stroke":"none"}}),_c('circle',{attrs:{"cx":"13","cy":"13","r":"12.5","fill":"none"}})]),_c('g',{attrs:{"fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","data-name":"Group 19404"}},[_c('path',{attrs:{"data-name":"Line 1","d":"M16.018 13h-5.825"}}),_c('path',{attrs:{"data-name":"Path 11743","d":"M13.105 9.88L9.985 13l3.12 3.12"}})])])
          )
        }
      }
    